import { render, staticRenderFns } from "./tesoreria.vue?vue&type=template&id=54a24c34&"
import script from "./tesoreria.vue?vue&type=script&lang=js&"
export * from "./tesoreria.vue?vue&type=script&lang=js&"
import style0 from "./tesoreria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports